export const getSchedulingPageWrapperStyles = (isLessThanMD: boolean) => {
	return {
		display: 'flex',
		flexDirection: isLessThanMD ? 'column' : 'row',
		alignItems: 'start',
		width: '100%',
		maxWidth: '1480px',
		mx: 'auto',
	};
};

export const getSchedulingPageLeftImageStyles = (isLessThanMD: boolean) => {
	return { width: isLessThanMD ? '100%' : '60%' };
};

export const getSchedulingPageStepperWrapperStyles = (isLessThanMD: boolean, isLessThanSM: boolean) => {
	return { width: isLessThanMD ? '100%' : '40%', padding: isLessThanSM ? '16px' : '30px 50px 0 50px' };
};
